import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage        from "./pages/HomePage";
import EditorPage      from "./pages/EditorPage";
import ExplorePage     from "./pages/ExplorePage";
import BlogPage        from "./pages/BlogPage";
import BlogPostPage    from "./pages/BlogPostPage";
import AdminPage       from "./pages/AdminPage";
import LoginPage       from "./pages/LoginPage";
import SharedPenPage   from "./pages/SharedPenPage";
import ResetPassword   from "./ResetPassword"; // ← ADD THIS

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"              element={<HomePage />}      />
        <Route path="/editor"        element={<EditorPage />}    />
        <Route path="/explore"       element={<ExplorePage />}   />
        <Route path="/blog"          element={<BlogPage />}      />
        <Route path="/blog/:slug"    element={<BlogPostPage />}  />
        <Route path="/admin"         element={<AdminPage />}     />
        <Route path="/login"         element={<LoginPage />}     />
        <Route path="/shared"        element={<SharedPenPage />} />
        <Route path="/reset-password" element={<ResetPassword />} /> {/* ← ADD THIS */}
        <Route path="*"              element={<HomePage />}      />
      </Routes>
    </BrowserRouter>
  );
}